<template>
  <div class="trend-live">
    <div class="trend-live__controls">
      <div class="trend-live__controls__switch">
        <div class="trend-live__controls__switch__team">
          <div class="trend-live__controls__switch__team__name">{{ homeTeam.colloquial_name }}</div>
          <div class="trend-live__controls__switch__team__logo">
            <img :src="homeTeam.logo" alt="" />
          </div>
        </div>
        <div class="trend-live__controls__switch__switch">
          <BSwitch v-model="booleanIsAwayTeamSelected" :size="stringSize" />
        </div>
        <div class="trend-live__controls__switch__team">
          <div class="trend-live__controls__switch__team__logo">
            <img :src="visitingTeam.logo" alt="" />
          </div>
          <div class="trend-live__controls__switch__team__name">{{ visitingTeam.colloquial_name }}</div>
        </div>
      </div>
      <div class="trend-live__controls__radio">
        <div>
          <BRadio v-model="numberTrendType" :native-value="1" :size="stringSize">
            Acumulado
          </BRadio>
        </div>
        <div>
          <BRadio v-model="numberTrendType" :native-value="2" :size="stringSize">
            Por periodos
          </BRadio>
        </div>
      </div>
    </div>
    <div v-for="(objectData, index) of arrayChartsData" :key="index" class="trend-live__graph">
      <div class="trend-live__graph__title">{{ objectData.name }}</div>
      <div class="trend-live__graph__categories">
        <div class="trend-live__graph__categories__label">
          Categoría:
        </div>
        <div class="trend-live__graph__categories__select">
          <BSelect
            :value="objectData.objectGraphProps.objectSubcategorySelected"
            expanded
            @input="onInputCategory($event, objectData)"
          >
            <option
              v-for="(objectSubcategory, index) of objectData.arraySubcategories"
              :value="objectSubcategory"
              :key="50 + index"
            >
              {{ objectSubcategory.name }}
            </option>
          </BSelect>
        </div>
      </div>
      <div class="trend-live__graph__controls-graph">
        <div class="trend-live__graph__controls-graph__controls">
          <div
            v-for="(objectSubcategory, index) of objectData.arraySubcategories"
            :key="200 + index"
            class="trend-live__graph__controls-graph__controls__button"
            :class="{ 'is-selected': objectSubcategory.id === objectData.objectGraphProps.numberCategoryId }"
            role="button"
            @click="onInputCategory(objectSubcategory, objectData)"
          >
            {{ objectSubcategory.name }}
          </div>
        </div>
        <div class="trend-live__graph__controls-graph__graph">
          <ChartTrendLive
            :typeId="numberTrendType"
            :teamTypeSelected="stringTeamTypeSelected"
            :subcategorySelected="objectData.objectGraphProps.objectSubcategorySelected"
            :teamId="numberTeamId"
            :types="arrayTrendTypes"
            :key="numberTrendType"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'TrendLive',
  components: {
    ChartTrendLive: () => import('@/components/Elements/NextMatches/ChartTrendLive'),
    BRadio: async () => {
      const { BRadio } = await import('buefy/dist/esm/radio');
      return BRadio;
    },
    BSelect: async () => {
      const { BSelect } = await import('buefy/dist/esm/select');
      return BSelect;
    },
    BSwitch: async () => {
      const { BSwitch } = await import('buefy/dist/esm/switch');
      return BSwitch;
    },
  },
  data() {
    return {
      numberTrendType: 1,
      booleanIsAwayTeamSelected: false,
      arrayTrendTypes: [
        { id: 1, name: 'Acumulado' },
        { id: 2, name: 'Por Períodos' },
      ],
      arrayChartsData: [],
    };
  },
  computed: {
    ...mapState(['windowWidth']),
    ...mapState('general', ['booleanIsStatisticModalOpen']),
    ...mapState('nextGeneral', ['gameForAnalysis']),
    ...mapGetters('nextGeneral', [
      'homeTeam',
      'visitingTeam',
      'showLiveData',
      'showPostMatchData',
      'arrayFilledDataSortedByPriority',
    ]),
    stringSize() {
      return this.windowWidth < 441 ? 'is-small' : '';
    },
    stringTeamTypeSelected() {
      return this.numberTeamId === this.gameForAnalysis.visiting_team ? 'visitingTeam' : 'homeTeam';
    },
    numberTeamId() {
      const numberTeamId = this.booleanIsAwayTeamSelected
        ? this.gameForAnalysis.visiting_team
        : this.gameForAnalysis.home_team;
      return numberTeamId || 0;
    },
  },
  watch: {
    booleanIsStatisticModalOpen: {
      immediate: true,
      handler(newValue) {
        if (!newValue) {
          this.numberTrendType = 1;
          this.booleanIsAwayTeamSelected = false;
        }
      },
    },
    arrayFilledDataSortedByPriority: {
      immediate: true,
      handler(newValue) {
        if (this.arrayChartsData.length === 0) {
          if (newValue && newValue.length) {
            this.arrayChartsData = newValue.map(dataObject => {
              const arraySubcategories = Object.values(dataObject.subcategories);
              return {
                ...dataObject,
                arraySubcategories,
                objectGraphProps: {
                  objectSubcategorySelected: arraySubcategories[0],
                  numberCategoryId: arraySubcategories[0].id,
                },
              };
            });
          } else {
            this.arrayChartsData = [];
          }
        }
      },
    },
  },
  methods: {
    onInputCategory(objectSubcategory, objectData) {
      objectData.objectGraphProps.numberCategoryId = objectSubcategory.id;
      objectData.objectGraphProps.objectSubcategorySelected = objectSubcategory;
    },
  },
};
</script>

<style scoped lang="scss">
.trend-live {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  &__controls {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 8px;
    width: 100%;
    max-width: 900px;

    &__switch {
      &__team {
        display: flex;
        align-items: center;

        &__name {
          font-family: Avenir-Demi-Medium, sans-serif;
          font-size: 16px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #1e2021;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &__logo {
          height: 32px;
          width: 32px;
          margin: 10px;

          & > img {
            height: 32px;
            width: 32px;
          }
        }
      }

      &__switch {
        margin: 0 14px 0 12px;
        padding-top: 4px;
      }
    }

    &__radio {
      & > div {
        display: flex;
      }
    }

    & > div {
      height: 52px;
      width: 100%;
      border: solid 1px #d9d9d9;
      border-radius: 26px;
      display: flex;
      justify-content: center;
      align-items: center;

      &:first-child {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      &:last-child {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        justify-content: space-around;
      }
    }

    @media screen and (max-width: 870px) {
      grid-template-columns: 1fr;
      column-gap: 0;
      row-gap: 8px;

      & > div {
        &:first-child {
          border-top-right-radius: 26px;
          border-bottom-right-radius: 26px;
        }

        &:last-child {
          border-top-left-radius: 26px;
          border-bottom-left-radius: 26px;
          display: flex;
          justify-content: center;

          & > div {
            height: 100%;
            width: 100%;
            margin: 0 22px;
            display: flex;
            align-items: center;

            &:first-child {
              justify-content: flex-end;
            }
          }
        }
      }
    }
  }

  &__graph {
    width: 100%;
    max-width: 1000px;
    margin-top: 48px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    &__title {
      margin-bottom: 32px;
      font-family: Avenir-Bold, sans-serif;
      font-size: 28px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: left;
      color: #000;
    }

    &__categories {
      display: none;

      &__label {
        padding-left: 4px;
        font-family: Roboto-Regular, sans-serif;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.31;
        letter-spacing: -0.13px;
        text-align: center;
        color: #80868b;
      }

      &__select {
        width: 100%;
      }
    }

    &__controls-graph {
      width: 100%;
      display: grid;
      grid-template-columns: 30% 65%;
      column-gap: 5%;

      &__controls {
        width: 100%;

        & > div {
          width: 100%;
          margin: 4px 0;
          border-radius: 7px;
          border: solid 1px #cad6e1;
          background-color: #fff;
          padding: 12px 10px;
          font-family: Avenir-Demi-Medium, sans-serif;
          font-size: 15px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: center;
          color: #1e2021;
          cursor: pointer;

          &.is-selected {
            border: solid 1px #132739;
            background-color: #e5f6b6;
          }

          &:first-child {
            margin-top: 0;
          }
        }
      }
    }

    @media screen and (max-width: 1142px) {
      &__controls-graph {
        grid-template-columns: 32% 68%;
        column-gap: 0;
      }
    }

    @media screen and (max-width: 1040px) {
      &__categories {
        text-align: center;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        max-width: 530px;
        margin-bottom: 16px;
      }

      &__controls-graph {
        grid-template-columns: 1fr;
        column-gap: 0;

        &__controls {
          display: none;
        }
      }
    }
  }

  @media screen and (max-width: 640px) {
    &__controls {
      &__switch {
        &__team {
          &__name {
            font-size: 14px;
          }

          &__logo {
            height: 28px;
            width: 28px;
            margin: 10px;

            & > img {
              height: 28px;
              width: 28px;
            }
          }
        }
      }

      & > div {
        height: 42px;
      }
    }

    &__graph {
      margin-top: 12px;
      &__title {
        margin-bottom: 16px;
        font-family: Avenir-Demi, sans-serif;
        font-size: 22px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #000;
      }
    }
  }

  @media screen and (max-width: 440px) {
    &__controls {
      row-gap: 4px;
      &__switch {
        &__team {
          &__name {
            font-size: 11px;
          }

          &__logo {
            height: 22px;
            width: 22px;
            margin: 10px;

            & > img {
              height: 22px;
              width: 22px;
            }
          }
        }
      }

      & > div {
        height: 30px;
      }
    }

    &__graph {
      margin-top: 12px;
      &__title {
        margin-bottom: 10px;
        font-size: 17px;
      }

      &__categories {
        &__label {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.trend-live__controls__switch__switch {
  & > .switch input[type='checkbox'] + .check {
    background: rgba(125, 212, 33, 0.9);
  }

  & > .switch {
    margin-right: 0;

    & .control-label {
      display: none;
    }

    &:hover input[type='checkbox'] + .check {
      background: rgba(125, 212, 33, 0.9);
    }
  }
}

.trend-live__controls__radio {
  @media screen and (max-width: 640px) {
    & label.b-radio.radio {
      & span.control-label {
        font-size: 14px;
      }
    }
  }

  @media screen and (max-width: 440px) {
    & label.b-radio.radio {
      & span.control-label {
        font-size: 11px;
      }
    }
  }
}
</style>
